<template>

  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class = "heading" >Change Stage Info</md-dialog-title>

     

      <md-dialog-content >
        <form id = "top" novalidate @submit.prevent="doSaveUser">

            <div>
                <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.costRelevant')">
                    <label size="lg" class = "textlabel" for="costRelevant">CostRelevant</label>
                    <md-input name="costRelevant"
                        id="costRelevant"
                        autocomplete="new-password"
                        v-model="dataForm.costRelevant"
                        ref = "top"
                    />
                    <div>
                    <div class="md-error" v-if="!$v.dataForm.costRelevant.required">costRelevant is required<br/></div>
                    <div class="md-error" v-else-if="!$v.dataForm.costRelevant.minLength">Invalid costRelevant<br/></div>
                </div>
                </md-field>
            </div>

            <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.freightType')">
                    <label size="lg" class = "textlabel" for="freightType">Freight Type</label>
                    <md-input name="freightType"
                        id="freightType"
                        autocomplete="new-password"
                        v-model="dataForm.freightType"
                        ref = "top"
                    />
                    <div>
                    <div class="md-error" v-if="!$v.dataForm.freightType.required">freightType is required<br/></div>
                    <div class="md-error" v-else-if="!$v.dataForm.freightType.minLength">Invalid freightType<br/></div>
                </div>
                </md-field>
            </div>


            <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.driverId')">
                    <label size="lg" class = "textlabel" for="freightType">Driver</label>
                    <md-input name="driverId"
                        id="driverId"
                        autocomplete="new-password"
                        v-model="dataForm.driverId"
                        ref = "top"
                        disabled
                    />
                    <div>
                </div>
                </md-field>
            </div>


        <div class = "layout">
          <md-field   :class="getValidationClass('dataForm.containerNo')">
            <label size="lg" class = "textlabel" for="containerNo">CONTAINER #</label>
            <md-input name="containerNo"
                      id="containerNo"
                      autocomplete="new-password"
                      v-model="dataForm.containerNo"
                      ref = "top"
            />
            <div>
              <div class="md-error" v-if="!$v.dataForm.containerNo.required">containerNo is required<br/></div>
              <div class="md-error" v-else-if="!$v.dataForm.containerNo.minLength">Invalid containerNo<br/></div>
            </div>
          </md-field>
        </div>


        <div class = "layout">
            <md-field >
            <label for="Stage Status">Chassis No</label>
            <md-input name="chassisNo"
                      id="chassisNo"
                      autocomplete="new-password"
                      v-model="dataForm.chassisNo"
            />
            <div>
              <div class="md-error" v-if="!$v.dataForm.chassisNo.required">chassisNo is required<br/></div>
              <div class="md-error" v-else-if="!$v.dataForm.chassisNo.minLength">Invalid chassisNo<br/></div>
            </div>
          </md-field>
        </div>


        <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.carrier')">
                    <label size="lg" class = "textlabel" for="freightType">Carrier</label>
                    <md-input name="carrier"
                        id="carrier"
                        autocomplete="new-password"
                        v-model="dataForm.carrier"
                        ref = "top"
                        disabled
                    />
                    <div>
                </div>
                </md-field>
        </div>


        <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.stageConfirmComment')">
                    <label size="lg" class = "textlabel" for="freightType">Confirm Comment</label>
                    <md-input name="stageConfirmComment"
                        id="stageConfirmComment"
                        autocomplete="new-password"
                        v-model="dataForm.stageConfirmComment"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>




        <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.totalHours')">
                    <label size="lg" class = "textlabel" for="freightType">Total hours</label>
                    <md-input name="totalHours"
                        id="totalHours"
                        autocomplete="new-password"
                        v-model="dataForm.totalHours"
                        ref = "top"
                        disabled
                    />
                    <div>
                </div>
                </md-field>
        </div>


        <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.waitingTimePaidOut')">
                    <label size="lg" class = "textlabel" for="waitingTimePaidOut">Driver Waiting Time</label>
                    <md-input name="waitingTimePaidOut"
                        id="waitingTimePaidOut"
                        autocomplete="new-password"
                        v-model="dataForm.waitingTimePaidOut"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>

        <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.offsiteScale')">
                    <label size="lg" class = "textlabel" for="waitingTimePaidOut">Off Stie Scale</label>
                    <md-input name="offsiteScale"
                        id="offsiteScale"
                        autocomplete="new-password"
                        v-model="dataForm.offsiteScale"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>

        <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.checkPoint')">
                    <label size="lg" class = "textlabel" for="waitingTimePaidOut">Drop Off CP</label>
                    <md-input name="checkPoint"
                        id="checkPoint"
                        autocomplete="new-password"
                        v-model="dataForm.checkPoint"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>

        <h1>All below are Local Time</h1>
        <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.checkInLocal')">
                    <label size="lg" class = "textlabel" for="checkInLocal">Arrive Terminal Date</label>
                    <md-input name="checkInLocal"
                        id="checkInLocal"
                        autocomplete="new-password"
                        v-model="dataForm.checkInLocal"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>


        <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.checkInLocalTime')">
                    <label size="lg" class = "textlabel" for="checkInLocalTime">Arrive Terminal Time</label>
                    <md-input name="checkInLocalTime"
                        id="checkInLocalTime"
                        autocomplete="new-password"
                        v-model="dataForm.checkInLocalTime"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>



        <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.checkOutLocal')">
                    <label size="lg" class = "textlabel" for="checkOutLocal">Leave Terminal Date</label>
                    <md-input name="checkOutLocal"
                        id="checkOutLocal"
                        autocomplete="new-password"
                        v-model="dataForm.checkOutLocal"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>


        <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.checkOutLocalTime')">
                    <label size="lg" class = "textlabel" for="checkOutLocalTime">Leave Terminal Time</label>
                    <md-input name="checkOutLocalTime"
                        id="checkOutLocalTime"
                        autocomplete="new-password"
                        v-model="dataForm.checkOutLocalTime"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>

        <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.taskStartLocal')">
                    <label size="lg" class = "textlabel" for="taskStartLocal">Start Date</label>
                    <md-input name="taskStartLocal"
                        id="taskStartLocal"
                        autocomplete="new-password"
                        v-model="dataForm.taskStartLocal"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>

        <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.taskStartLocalTime')">
                    <label size="lg" class = "textlabel" for="taskStartLocalTime">Start Time</label>
                    <md-input name="taskStartLocalTime"
                        id="taskStartLocalTime"
                        autocomplete="new-password"
                        v-model="dataForm.taskStartLocalTime"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>


         <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.taskEndLocal')">
                    <label size="lg" class = "textlabel" for="taskEndLocal">End Date</label>
                    <md-input name="taskEndLocal"
                        id="taskEndLocal"
                        autocomplete="new-password"
                        v-model="dataForm.taskEndLocal"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>


        <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.taskEndLocalTime')">
                    <label size="lg" class = "textlabel" for="taskEndLocalTime">End Time</label>
                    <md-input name="taskEndLocalTime"
                        id="taskEndLocalTime"
                        autocomplete="new-password"
                        v-model="dataForm.taskEndLocalTime"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>


        <calling-api path="/api/w/ccic/photo/get">
          <view-image :key="p.photoUrl" :src="p.photoUrl" v-for="p in photos">
            <p>Photo Type: {{getPhotoName(p)}}</p>
          </view-image>
        </calling-api>





        







        



















            </div>

            <div class = "alwaysShow">
                <div >
                    <callingApiCenter class = "custButtonRight" type="bar" :paths="['/api/w/DOs/getdoheader','/api/w/users','/api/w/gst/loadlist', '/api/w/gstConfirm/WebUpdateConfirmStages']"></callingApiCenter>
                    <md-dialog-actions >
                    <md-button class="md-raised custButton " @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
                    <md-button type="submit" class="md-raised custButton "><span class="icons-center material-icons">create</span>Save</md-button>
                    </md-dialog-actions>
                </div>
            </div>

        </form>

      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
    
  }
  

  .alwaysShow {
  position: fixed;
  
  right: 60px;
  top : 30px;
}


    .redButton{

        background-color: #c50000;
        z-index: 4;
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    }


.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}



  .custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}



    .heading{
      padding-top: 10px;
     margin-bottom: 0;
      color: #555555;
      width: 92%;
      line-height: 3;
      font-size: 40px;
      font-family: Roboto Slab;
      margin-left: 44px;


}

  .layout{
      padding-top: 7px;
      padding-bottom: 7px;
      width: 92%;
      line-height: 1.5;
      color: #555555;
    
      font-family: Roboto Slab;
      margin: auto;
  }

  .layoutHalf{
      display:inline-block;
      padding-top: 7px;
      padding-bottom: 7px;
      width: 50%;
      line-height: 1.5;
      color: #555555;
      font-family: Roboto Slab;
      margin: auto;
      padding-left: 15px;
  }


  .md-table-row
{
  background: white;
}


.md-table.md-theme-default .md-table-row.md-selected-single
{
background: #726a95;
}



</style>
<script>
  import { validationMixin } from 'vuelidate';
  import dateFormat from '../utils/dateFormat';
  import { mapGetters } from 'vuex';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialdataForm = () => ({
    salesOffice: null,
    costRelevant: null,
    freightType: null,
    driverId: null,
    containerNo: null,
    chassisNo: null,
    carrier: null,
    stageConfirmComment: null,
    waitingTimePaidOut: null,
    totalHours: null,
    offsiteScale: null,
    checkPoint: null,
    checkIn: null,
    checkOut: null,
    taskStart:null,
    taskEnd: null,
    checkInLocal: null,
    checkOutLocal: null,
    taskStartLocal:null,
    taskEndLocal: null,
    checkInLocalTime: null,
    checkOutLocalTime: null,
    taskStartLocalTime:null,
    taskEndLocalTime: null,
    loadKeyWithStageNo: null,
    action: null,








    
  });

  export default {
    components: { AutocompleteCcicLocationSelect ,callingApiCenter},
    mixins: [validationMixin],
    props: {
      mode: String,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      items: [],
      photos: [],
      selected:null,
      drivers: [],
      loadList: [],
      dispatchers: [],
      ccicQcUsers: [],
    }),
    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
      ]),
      
    },

    validations: {
      dataForm: {
        salesOffice: {
          required,
          minLength: minLength(3),
        },

        costRelevant:{},
        freightType:{},
        driverId:{},
        containerNo:{},
        chassisNo:{},
        carrier:{},
        stageConfirmComment : {},
        waitingTimePaidOut: {},
        totalHours:{},
        offsiteScale:{},
        checkPoint:{},
        checkIn:{},
        checkOut:{},
        taskStart:{},
        taskEnd:{},








      },
    },

 
    methods: {



      timeConvert(localDate,localTime, timeZone){
        if (localDate == null) return null
        if (localTime == null) return  null
        if (timeZone == null) return  null
        return moment.tz(localDate + ' ' + localTime, timeZone).toISOString()
      },


      

      displayLocalTime(timeStamp, timeZone){
        if (timeStamp == null) return null
        if (timeZone == null) return  null
        return moment.tz(timeStamp, timeZone).format('HH:mm:ss')
      },


      displayLocalDate(timeStamp, timeZone){
        if (timeStamp == null) return null
        if (timeZone == null) return  null
        return moment.tz(timeStamp, timeZone).format('YYYY-MM-DD')
      },


    

      async openDialog(existingUser) {
        this.$store.commit('clearApiError');
        this.$v.dataForm.$reset();
        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialdataForm();
        this.dataForm.username = this.getUserProfile.username;


        
        

        // console.log(existingUser.checkIn);
        // console.log(moment(existingUser.checkIn).format());
        // console.log(moment.tz(existingUser.checkIn, "America/New_York").format());
        // console.log(moment.tz(existingUser.checkIn, "America/Los_Angeles").format());
        // var ny = moment.tz(existingUser.checkIn, "America/New_York");
        // console.log(ny.format());
        // console.log(ny.toISOString());

        const timeStamp = '2020-12-28T20:16:04.317Z';
        const timeZoneNY = 'America/New_York';
        const timeZoneLA = 'America/Los_Angeles';


        




        if (existingUser) {

          console.log(existingUser);

            this.dataForm.salesOffice = existingUser.salesOffice;
            this.dataForm.loadKeyWithStageNo = existingUser.loadKeyWithStageNo;
            this.dataForm.costRelevant = existingUser.costRelevant;
            this.dataForm.freightType = existingUser.freightType;
            this.dataForm.driverId = existingUser.driverId;
            this.dataForm.containerNo = existingUser.containerNo;
            this.dataForm.chassisNo = existingUser.chassisNo;
            this.dataForm.carrier = existingUser.carrier;
            this.dataForm.stageConfirmComment = existingUser.stageConfirmComment;
            this.dataForm.waitingTimePaidOut = existingUser.waitingTimePaidOut;
            this.dataForm.totalHours = existingUser.totalHours;
            this.dataForm.offsiteScale = existingUser.offsiteScale;
            this.dataForm.checkPoint = existingUser.checkPoint;
            this.dataForm.checkIn = existingUser.checkIn;
            this.dataForm.checkOut = existingUser.checkOut;
            this.dataForm.taskStart = existingUser.taskStart;
            this.dataForm.taskEnd = existingUser.taskEnd;

            this.photos = existingUser.pictureList;

            this.dataForm.checkInLocal = dateFormat.gstDateFormat(existingUser.checkIn);
            this.dataForm.checkOutLocal = dateFormat.gstDateFormat(existingUser.checkOut);
            this.dataForm.taskStartLocal = dateFormat.gstDateFormat(existingUser.taskStart);
            this.dataForm.taskEndLocal = dateFormat.gstDateFormat(existingUser.taskEnd);

            this.dataForm.checkInLocalTime = dateFormat.time(existingUser.checkIn);
            this.dataForm.checkOutLocalTime = dateFormat.time(existingUser.checkOut);
            this.dataForm.taskStartLocalTime = dateFormat.time(existingUser.taskStart);
            this.dataForm.taskEndLocalTime = dateFormat.time(existingUser.taskEnd);
        }

        this.showDialog = true;
      },

      
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },



     cancalAction(){
        this.showDialog = false;
        this.$store.commit('clearApiError');
     },


     convertTime(){
        // console.log(existingUser.checkIn);
        // console.log(moment(existingUser.checkIn).format());
        // console.log(moment.tz(existingUser.checkIn, "America/New_York").format());
        // console.log(moment.tz(existingUser.checkIn, "America/Los_Angeles").format());
        // var ny = moment.tz(existingUser.checkIn, "America/New_York");
        // console.log(ny.format());
        // console.log(ny.toISOString());
     },

     getPhotoName(photo) {
        const photoName = decodeURI(photo.photoUrl.replace(/.*\//g, ""));
        return `${this.filePrefixForEachFile || ''}${photoName}`;
      },

    async doSaveUser() {
       
        this.$v.dataForm.$touch();
        console.log(JSON.stringify(this.dataForm));
        const req = this.dataForm;
        
        const timeZoneNY = 'America/New_York';
        this.dataForm.checkIn = dateFormat.getLocalTimeStamp(this.dataForm.checkInLocal, this.dataForm.checkInLocalTime);
        this.dataForm.checkOut = dateFormat.getLocalTimeStamp(this.dataForm.checkOutLocal, this.dataForm.checkOutLocalTime);
        this.dataForm.taskStart = dateFormat.getLocalTimeStamp(this.dataForm.taskStartLocal, this.dataForm.taskStartLocalTime);
        this.dataForm.taskEnd = dateFormat.getLocalTimeStamp(this.dataForm.taskEndLocal, this.dataForm.taskEndLocalTime);
        req.action = 'CHANGE';
        console.log(req);


        //await  api.post("/api/w/gstConfirm/WebUpdateConfirmStages", req)
        await  newAPIPost("/api/w/gstConfirm/WebUpdateConfirmStages", req)
        .then(() => {
        this.$store.commit('clearApiError');
        this.showDialog = false;
        $('.btn-search-special-form-stages')
        .click(); });
         this.$store.commit('clearApiError');
      },
    },
  };
</script>
